let sessionEpoch = 0;

export function captureSessionEpoch(): number {
  return sessionEpoch;
}

export function isSessionEpochCurrent(epoch: number): boolean {
  return epoch === sessionEpoch;
}

export function advanceSessionEpoch(): number {
  return ++sessionEpoch;
}
